/**
 * File Field Type enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum FILE_FIELD_TYPE {
	SIMPLE = "simple",
	LIST = "list"
	//GALLERY = "gallery"
}

export type FILE_FIELD_TYPE_string = keyof typeof FILE_FIELD_TYPE;

export const FILE_FIELD_TYPE_default: FILE_FIELD_TYPE_string = "SIMPLE";
